import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ToolDetails} from "@app/tool/model/toolDetails.model";
import {UntypedFormControl, UntypedFormGroup} from "@angular/forms";

@Component({
    selector: 'app-special-identifiers-form',
    templateUrl: './special-identifiers-form.component.html',
    styleUrls: ['./special-identifiers-form.component.scss']
})
export class SpecialIdentifiersFormComponent implements OnInit, OnChanges {

    @Input() showValidations = false;
    @Input() toolDetails: ToolDetails;

    specialIdentifiersForm: UntypedFormGroup;

    constructor() {
    }

    ngOnInit() {
        this.specialIdentifiersForm = new UntypedFormGroup({
            isToolLifeMonitoredInSap: new UntypedFormControl(this.toolDetails.isToolLifeMonitoredInSap),
            isToolLifeMonitoredInMes: new UntypedFormControl(this.toolDetails.isToolLifeMonitoredInMes),
            isToolLifeMonitoredInPlc: new UntypedFormControl(this.toolDetails.isToolLifeMonitoredInPlc),
            hasMaintenaceAtLine: new UntypedFormControl(this.toolDetails.hasMaintenaceAtLine),
            excludedFromMaintenance: new UntypedFormControl(this.toolDetails.excludedFromMaintenance),
            isToolStationedAtERSA: new UntypedFormControl(this.toolDetails.isToolStationedAtERSA),
            excludedFromReturn: new UntypedFormControl(this.toolDetails.excludedFromReturn)
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['toolDetails'] && this.toolDetails && this.specialIdentifiersForm) {
            this.loadFormValues(this.toolDetails);
        }
    }

    value() {
        return this.specialIdentifiersForm.value;
    }

    onToolStationedAtERSAChanged(value) {
        if (value) {
            this.specialIdentifiersForm.controls['excludedFromReturn'].setValue(false);
        }
    }

    onToolExcludedFromReturnChanged(value) {
        if (value) {
            this.specialIdentifiersForm.controls['isToolStationedAtERSA'].setValue(false);
        }
    }

    onToolHasMaintenanceAtLineChanged(value) {
        if (value) {
            this.specialIdentifiersForm.controls['excludedFromMaintenance'].setValue(false);
        }
    }

    onToolIsExcludedFromMaintenanceChanged(value) {
        if (value) {
            this.specialIdentifiersForm.controls['hasMaintenaceAtLine'].setValue(false);
        }
    }

    private loadFormValues(toolDetails: ToolDetails) {
        this.specialIdentifiersForm.setValue({
            isToolLifeMonitoredInSap: toolDetails.isToolLifeMonitoredInSap,
            isToolLifeMonitoredInMes: toolDetails.isToolLifeMonitoredInMes,
            isToolLifeMonitoredInPlc: toolDetails.isToolLifeMonitoredInPlc,
            hasMaintenaceAtLine: toolDetails.hasMaintenaceAtLine,
            excludedFromMaintenance: toolDetails.excludedFromMaintenance,
            isToolStationedAtERSA: toolDetails.isToolStationedAtERSA,
            excludedFromReturn: toolDetails.excludedFromReturn
        });
    }
}
